module.exports = __webpack_public_path__ + "static/img/competitiveness_02@3x.a6a258f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/competitiveness_02@3x.png
// module id = IS1h
// module chunks = 1